import PlayerDelete from "./PlayerDelete";

export default PlayerDelete;
